import { createSlice } from '@reduxjs/toolkit';

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState: {
    userRole: '',
  },
  reducers: {
    setUserRole: (state, action) => {
      if (!import.meta.env.PROD) {
        console.log('[userRoleSlice] setUserRole', action.payload);
        console.trace('setUserRole trace');
      }
      state.userRole = action.payload;
    },
  },
});

export const { setUserRole } = userRoleSlice.actions;

export const userRoleData = (state) => state.userRole;
export default userRoleSlice.reducer;
